import React from "react";
import Danger from "././components/Danger";
import Success from "./components/Success";
import Info from "././components/info";
import Processing from "././components/Processing";
import { motion } from "framer-motion";

function SnackBar({ message = "Default message", type = "success" }) {
  return (
    <div
      className={
        "fixed top-12 md:top-auto w-fit md:bottom-12 right-1 md:right-8"
      }
    >
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: -50 }}
        exit={{ opacity: 0, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div
          className={
            "py-1 px-2 rounded-lg " +
            "bg-sunny-secondary border border-solid border-sunny-border dark:bg-dark-secondary dark:border-dark-border"
          }
        >
         {type === "success" ? (
            <Success type={type} message={message} />
          ) : type === "danger" ? (
            <Danger message={message} />
          ) : type === "processing" ? (
            <Processing message={message} />
          ) : type === "info" ? (
            <Info message={message} />
          ) : null}
                  </div>
      </motion.div>
    </div>
  );
}

export default SnackBar;
